export default "__VITE_ASSET__DEZbTO$I__"